import React, { useEffect } from "react";
import { Button, Typography, List } from "antd";
import { getdoctor } from "../../services/doctor/shift schedule/shift_schedule";
import Loader from "../Loader";
import PropTypes from 'prop-types';
import { Modal } from "react-bootstrap";


const { Text } = Typography;

const DoctorSelectPopup = ({
  doctorList,
  showModal,
  handleCancel,
  setSelectedDoctor
}) => {

    const [doctors, setDoctors] = React.useState(doctorList);   
    const [loading, setLoading] = React.useState(false);


  return (
    loading ? <Loader/> :
    <Modal
      show={showModal}
      maskClosable={false} 
        keyboard={false}
      onHide={handleCancel}
      centered
      size={ "lg"} 
    >
      <Modal.Header closeButton>
        <Modal.Title>Select Doctor</Modal.Title>
      </Modal.Header>

      <Modal.Body>
       
          {doctors.length > 0 ? (
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                marginTop: "10px",
              }}
            >
              <List
                dataSource={doctors}
                bordered
                renderItem={(doctor) => (
                  <List.Item
                    key={doctor.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px",
                    }}
                  >
                    <div>
                      <div style={{ fontWeight: "bold" }}>
                        {doctor.name} {doctor.last_name}
                      </div>
                      <div>
                        <Text>
                          📞 {doctor.mobile} | 🎂 {doctor.date_of_birth} | Doctor ID:{" "}
                          {doctor.id}
                        </Text>
                      </div>
                    </div>
                    <Button
                      type="primary"
                      size="small"
                      onClick={(e) => {
                        
                        setSelectedDoctor(doctor);
                        
                      }}
                    >
                      Select Doctor
                    </Button>
                  </List.Item>
                )}
              />
            </div>
          ) : (
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <Text type="secondary">No Doctors found.</Text>
            </div>
          )}
        
      </Modal.Body>
    </Modal>
  );
};

export default DoctorSelectPopup;

DoctorSelectPopup.propTypes={
    showModal: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
    setSelectedDoctor:PropTypes.func.isRequired,
    doctorList:PropTypes.object.isRequired,

  };
